/**
 * Fetches a markdown document from public/docs/.
 * The sync-docs.js script copies all .md files there before start/build.
 */
export const fetchDoc = async (docPath) => {
  const url = `/content/${docPath}?v=${process.env.REACT_APP_BUILD_VERSION || Date.now()}`;
  const response = await fetch(url, { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`Failed to load doc: ${docPath} (${response.status})`);
  }
  const text = await response.text();
  // CloudFront returns index.html (status 200) for missing paths — detect and reject
  if (text.trimStart().toLowerCase().startsWith("<!doctype")) {
    throw new Error(`Document not found: ${docPath}`);
  }
  return text;
};
